// src/lib/passGate.ts
//
// One channel for every "this needs the pass" moment. The axios interceptor
// broadcasts a 402 here; PassGateDialog (mounted once, in the layout) shows
// the wall. Call sites only need to stay quiet — see isPassRequired.

export type GatedFeature = "mocks" | "solutions" | "contests";

export interface PassRequired {
  feature: GatedFeature;
  used?: number;
  limit?: number;
}

export const PASS_REQUIRED_EVENT = "gt:pass-required";

export function announcePassRequired(detail: PassRequired) {
  window.dispatchEvent(new CustomEvent<PassRequired>(PASS_REQUIRED_EVENT, { detail }));
}

/** True for a rejected ApiError or a resolved ApiResponse carrying the code.
 *  Callers use it to skip their own error toast — the dialog owns the moment. */
export function isPassRequired(x: unknown): boolean {
  return !!x && typeof x === "object" && (x as { errorCode?: string }).errorCode === "PASS_REQUIRED";
}
